import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assistant-medical-appointment-detail',
  templateUrl: './assistant-medical-appointment-detail.component.html',
  styleUrls: ['./assistant-medical-appointment-detail.component.css']
})
export class AssistantMedicalAppointmentDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
